<template>
  <iframe v-if="mcpLoaded" id="mcp-request-iframe" :src="iframeUrl" class="custom-iframe" frameborder="0"></iframe>
  <div v-else>
    <span>No Request Found</span>
  </div>
</template>
<script>
import { mapState } from 'pinia'
import { authStore } from '@/stores/auth'
import { inspectionStore } from '@/stores/inspection'
export default {
  name: 'McpRequest',
  props: {
    tab: {
      type: String,
      default: null
    },
    mcpLoaded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      guid: 'AA782740-D4B6-40AE-88EF-6F8E2660DBB2',
      baseUrl: window.config ? window.config.mcpUrl : ''
    };
  },
  mounted() {
    console.log('Viewing MCP', {
      baseUrl: this.baseUrl,
      t: this.profile.mcpToken,
      inspection: this.inspection
    })
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(inspectionStore, ['inspection']),
    iframeUrl() {
      return `${this.baseUrl}/blueprint?t=${this.profile.mcpToken}&vin=${this.inspection.vehicle.vin}&adasInspection=${this.inspection.adasInspection}`
    }
  },
  methods: {
    gotoProviders() {
      const iframe = document.getElementById('mcp-request-iframe');
      if (iframe && iframe.contentWindow) {
        console.log('Triggering ShowTab() in MCP')
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showTab',
            payload: {
              tab: 'Provider'
            }
          },
          '*'
        )
      }
    },
    showRepairLines() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showRepairLines',
            payload: null
          },
          '*'
        )
      }
    },
    scrubRepairData() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'scrubRepairData',
            payload: null
          },
          '*'
        )
      }
    },
    emailReport() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'emailReport',
            payload: null
          },
          '*'
        )
      }
    },
    showReport() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'showReport',
            payload: null
          },
          '*'
        )
      }
    },
    pushReportToCCC() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'pushToCCC',
            payload: null
          },
          '*'
        )
      }
    },
    sendToCalCopilot() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            type: 'triggerAction',
            action: 'sendToCalCopilot',
            payload: null
          },
          '*'
        )
      }
    },
    completeInspection() {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'completeInspection',
            payload: null
          },
          '*'
        )
      }
    },
    saveInspection(closeIt) {
      const iframe = document.getElementById('adas-inspection-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage(
          {
            id: this.guid,
            type: 'triggerAction',
            action: 'saveInspection',
            payload: {
              closeIt: closeIt
            }
          },
          '*'
        )
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-iframe {
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  height: 650px;
}
</style>